import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, Output, OnChanges, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';
import { GenericModalService, ModalSettingsInput, ModalMultiButton, ModalSettingsMessage } from '../shared/generic-modal/generic-modal.service';

import { PartnerFtpService } from './services/partner-ftp.service';
import { FtpDirectory } from './models/ftp-directory';
import { FtpFile } from './models/ftp-file';
import { FtpFileSystemBase } from './models/ftp-file-system-base';
import { DateTimeService } from '../shared/datetime/datetime.service';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';

@Component({
    templateUrl: './ftp-show-files.component.html',
    selector: 'ep-ftp-show-files',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxiColumnModule]
})
export class FtpShowFilesComponent implements OnInit, OnChanges {

    constructor(private partnerFtpService: PartnerFtpService, private loadingPanelService: LoadingPanelService, private modalService: GenericModalService, public dateTimeService: DateTimeService) { }

    @Input() partnerId: number;    
    @Input() visible: boolean;

    public isLoading = false;
    public files: FtpFileSystemBase[] = [];

    ngOnInit() {

    }

    ngOnChanges(changes: any) {
        if (changes.visible && this.visible === true) {
            this.refreshData();
        }
    }

    refreshData() {
        this.isLoading = true;
        this.files = []; 
        this.partnerFtpService.getDirectoriesAndFiles(this.partnerId).then(result => {
            if (result) {         
                result.Files.forEach(f => {
                    this.files.push(f);
                });

                result.Directories.forEach(d => this.parseRecursive(this.files, d))
            }
            else {
                this.files = [];
            }
            this.isLoading = false;
        }).catch(() => { this.isLoading = false; });
    }

    parseRecursive(files: FtpFileSystemBase[], directory: FtpDirectory) {
        directory.Files.forEach(f => {
            files.push(f);
        });

        directory.SubDirectories.forEach(d => this.parseRecursive(files, d)); // Run through all sub-directories
    }
}